<div class="timeline">
  <div class="timeline__container" fxLayout="row" fxLayoutAlign="center start">
    <ng-content></ng-content>
  </div>
</div>
